import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';
import { CheckCircle2, XCircle, MessageSquare, FileText, Calendar, MapPin, DollarSign } from 'lucide-react';
export function SharedOfferPage() {
  const {
    offerId
  } = useParams();
  const [status, setStatus] = useState<'pending' | 'approved' | 'rejected'>('pending');
  return <div className="min-h-screen bg-background text-textMain py-12 px-6" data-id="element-7063">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-2xl mx-auto" data-id="element-7064">
        <div className="mb-8 text-center" data-id="element-7065">
          <h1 className="text-2xl font-bold mb-2" data-id="element-7066">Offer Review</h1>
          <p className="text-textMuted" data-id="element-7067">
            Please review the terms below to proceed.
          </p>
        </div>

        {status !== 'pending' && <div className={`mb-6 p-4 rounded-xl flex items-center justify-center gap-2 font-medium ${status === 'approved' ? 'bg-green-500/10 text-green-500 border border-green-500/20' : 'bg-red-500/10 text-red-500 border border-red-500/20'}`} data-id="element-7068">
            {status === 'approved' ? <CheckCircle2 className="w-5 h-5" data-id="element-7069" /> : <XCircle className="w-5 h-5" data-id="element-7070" />}
            {status === 'approved' ? 'You have approved this offer.' : 'You have declined this offer.'}
          </div>}

        <div className="bg-surface border border-border rounded-2xl overflow-hidden mb-6" data-id="element-7071">
          <div className="p-6 border-b border-border bg-background/50" data-id="element-7072">
            <div className="flex items-center gap-4 mb-4" data-id="element-7073">
              <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center text-primary font-bold text-xl" data-id="element-7074">
                EB
              </div>
              <div data-id="element-7075">
                <h2 className="text-xl font-bold" data-id="element-7076">The Empty Bottle</h2>
                <p className="text-sm text-textMuted" data-id="element-7077">Chicago, IL</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-4 text-sm" data-id="element-7078">
              <div className="flex items-center gap-1.5 bg-surface px-3 py-1.5 rounded-lg border border-border" data-id="element-7079">
                <Calendar className="w-4 h-4 text-textMuted" data-id="element-7080" /> Jun 12, 2026
              </div>
              <div className="flex items-center gap-1.5 bg-surface px-3 py-1.5 rounded-lg border border-border" data-id="element-7081">
                <MapPin className="w-4 h-4 text-textMuted" data-id="element-7082" /> 400 Cap
              </div>
            </div>
          </div>

          <div className="p-6 space-y-6" data-id="element-7083">
            <div data-id="element-7084">
              <h3 className="text-sm font-semibold text-textMuted uppercase tracking-wider mb-3" data-id="element-7085">
                Financial Terms
              </h3>
              <div className="bg-background border border-border rounded-xl p-4 space-y-3" data-id="element-7086">
                <div className="flex justify-between items-center" data-id="element-7087">
                  <span className="font-medium" data-id="element-7088">Guarantee</span>
                  <span className="font-bold text-lg text-primary" data-id="element-7089">$1,500</span>
                </div>
                <div className="flex justify-between items-center text-sm" data-id="element-7090">
                  <span className="text-textMuted" data-id="element-7091">Backend</span>
                  <span data-id="element-7092">80% after $2,000</span>
                </div>
                <div className="flex justify-between items-center text-sm" data-id="element-7093">
                  <span className="text-textMuted" data-id="element-7094">Deposit</span>
                  <span data-id="element-7095">$750 (Due upon signing)</span>
                </div>
              </div>
            </div>

            <div data-id="element-7096">
              <h3 className="text-sm font-semibold text-textMuted uppercase tracking-wider mb-3" data-id="element-7097">
                Additional Terms
              </h3>
              <ul className="space-y-2 text-sm" data-id="element-7098">
                <li className="flex items-start gap-2" data-id="element-7099">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-7100" />
                  <span data-id="element-7101">Venue provides full backline and FOH engineer.</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-7102">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-7103" />
                  <span data-id="element-7104">$150 buyout for hospitality.</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-7105">
                  <AlertCircle className="w-4 h-4 text-amber-500 shrink-0 mt-0.5" data-id="element-7106" />
                  <span data-id="element-7107">
                    Radius Clause: 60 miles / 30 days before and after.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {status === 'pending' && <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-7108">
            <button onClick={() => setStatus('approved')} className="py-3 bg-primary text-background rounded-xl font-medium hover:bg-primaryHover transition-colors flex items-center justify-center gap-2" data-id="element-7109">
              <CheckCircle2 className="w-5 h-5" data-id="element-7110" /> Approve Offer
            </button>
            <button onClick={() => setStatus('rejected')} className="py-3 bg-surface border border-border rounded-xl font-medium hover:bg-surfaceHover transition-colors flex items-center justify-center gap-2 text-red-500" data-id="element-7111">
              <XCircle className="w-5 h-5" data-id="element-7112" /> Decline / Counter
            </button>
          </div>}
      </motion.div>
    </div>;
}
function AlertCircle(props: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-7113">
      <circle cx="12" cy="12" r="10" data-id="element-7114" />
      <line x1="12" y1="8" x2="12" y2="12" data-id="element-7115" />
      <line x1="12" y1="16" x2="12.01" y2="16" data-id="element-7116" />
    </svg>;
}